/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrderSearchDto
 */
export interface OrderSearchDto {
    /**
     * 
     * @type {string}
     * @memberof OrderSearchDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof OrderSearchDto
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrderSearchDto
     */
    externalOrderId?: string | null;
}

/**
 * Check if a given object implements the OrderSearchDto interface.
 */
export function instanceOfOrderSearchDto(value: object): value is OrderSearchDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function OrderSearchDtoFromJSON(json: any): OrderSearchDto {
    return OrderSearchDtoFromJSONTyped(json, false);
}

export function OrderSearchDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderSearchDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'description': json['description'] == null ? undefined : json['description'],
        'externalOrderId': json['externalOrderId'] == null ? undefined : json['externalOrderId'],
    };
}

export function OrderSearchDtoToJSON(json: any): OrderSearchDto {
    return OrderSearchDtoToJSONTyped(json, false);
}

export function OrderSearchDtoToJSONTyped(value?: OrderSearchDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'description': value['description'],
        'externalOrderId': value['externalOrderId'],
    };
}

